class GiftWrappingComponent extends HTMLElement {
	constructor() {
		super()

		this.cartDrawer = document.querySelector('m-cart-drawer')
		this.giftWrapId = this.dataset.giftWrapId;
		this.giftWrapping = this.dataset.giftWrapping;
		this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
		this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
		this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));
		this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
    this.cart = document.querySelector('m-cart-drawer');

		// When the gift-wrapping checkbox is checked or unchecked.
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      event.target.checked ? this.setGiftWrapping() : this.removeGiftWrapping();
    });

		if (this.cartDrawer) return;

		// If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrapping();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 & this.giftWrapsInCart != this.itemsInCart) {
      this.setGiftWrapping();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping === 'false') {
      this.setGiftWrapping();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping === 'true') {
      this.setGiftWrapping();
    }
	}

	setGiftWrapping() {
		this.loadingIcon.classList.add("show")
		const headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
		const config = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ 
				updates: {
        	[this.giftWrapId]: this.itemsInCart
      	},
				attributes: { 'gift-wrapping': true }
			})
    }
		this.updateCart(config);
	}

	removeGiftWrapping() {
		this.loadingIcon.classList.add("show")
		const headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
		const config = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ 
				updates: {
        	[this.giftWrapId]: 0
      	}, 
				attributes: { 'gift-wrapping': false }
			})
    }
    this.updateCart(config);
	}

  updateCart(request) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, request)
      .then((response) => response.json())
      .then((response) => {
        this.loadingIcon.classList.remove("show")
        if (document.body.classList.contains('template-cart')) {
          window.location.href = MinimogSettings.routes.cart;
          return;
        }
        if (this.cartDrawer) {
          this.cart.onCartDrawerUpdate();
          this.cartDrawer.classList.toggle('m-cart--empty', response.item_count === 0);
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, response);
        }
      }).catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('m-gift-wrapping-component', GiftWrappingComponent)

class GiftNoteComponent extends HTMLElement {
	constructor() {
		super()

		this.textarea = this.querySelector('textarea')
		this.status = this.querySelector('[data-gift-note-status]')
		this.saveButton = this.querySelector('[data-gift-note-save]')
		this.lastSaved = this.textarea ? this.textarea.value : ''
		if (!this.textarea) return

		// SAVE AS THEY TYPE.
		//
		// This used to listen for 'change', which a textarea fires only when it
		// loses focus. Anyone who typed a message and clicked Checkout straight
		// from the box never blurred it, so the note was never sent and the gift
		// arrived with nothing in it. Across 300 recent orders not one carried a
		// gift-note attribute, while two carried a message in the ordinary order
		// note -- those were the customers who happened to use the other box.
		this.textarea.addEventListener('input', this.queueSave.bind(this))

		// Belt and braces for the last keystrokes: blur, an explicit Save, and
		// anything that looks like leaving for checkout.
		this.textarea.addEventListener('blur', () => this.save(true))
		if (this.saveButton) {
			this.saveButton.addEventListener('click', (e) => { e.preventDefault(); this.save(true) })
		}
		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'hidden') this.save(true)
		})
		document.querySelectorAll('[name="checkout"], [href*="/checkout"]').forEach((el) => {
			el.addEventListener('click', () => this.save(true))
		})
	}

	queueSave() {
		this.setStatus('typing')
		clearTimeout(this.timer)
		this.timer = setTimeout(() => this.save(), 500)
	}

	save(force) {
		if (!this.textarea) return
		const value = this.textarea.value
		if (!force && value === this.lastSaved) return
		clearTimeout(this.timer)
		this.lastSaved = value
		this.setStatus('saving')

		// keepalive lets the request finish even if the page is already
		// navigating to checkout, which is exactly when it matters most.
		return fetch(`${MinimogSettings.routes.cart_update_url}`, {
			method: 'POST',
			headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' }),
			body: JSON.stringify({ attributes: { 'gift-note': value } }),
			keepalive: true,
		}).then(() => this.setStatus(value ? 'saved' : 'empty'))
		  .catch(() => this.setStatus('failed'))
	}

	setStatus(state) {
		if (!this.status) return
		const says = { typing: '', saving: 'Saving…', saved: 'Message saved',
		               empty: '', failed: 'Not saved — press Save' }
		this.status.textContent = says[state] || ''
		this.status.dataset.state = state
	}
}

customElements.define('m-gift-note-component', GiftNoteComponent)

class GiftWrappingQuantityInput extends MQuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();
    this.giftWrapping = document.querySelector('m-gift-wrapping-component');
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      
      this.giftWrapping.removeGiftWrapping();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 & this.giftWrapsInCart != this.itemsInCart) {
      this.update();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      this.update();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('m-gift-wrapping-input', GiftWrappingQuantityInput)